export default "__VITE_ASSET__LV_Inj$S__"